'use strict';

/**
 * Creates a pagination element that will
 * inject the necessary markup on the page
 * and will keep a dataset and paginated-dataset
 * in sync. Will also fire off events for when
 * the data is loaded, an arrow is clicked and
 * which direction the data is paginating.
 *
 * @example
 *  <pagination
 *      class="pagination-container"
 *      dataset="controller.model.data"
 *      paginated-dataset="controller.model.paginatedData"
 *  ></pagination>
 */

module.exports = /*@ngInject*/
function(
    _,
    AnthroConfig,
    Events
) {
    return {
        link: function(scope, element, attrs) {
            var m = scope.model = {
                currentPage: 1,
                itemsPerPage: AnthroConfig.pagination.defaultItemsPerPage,
                pagedData: [],
                totalPages: 1
            };

            var a = scope.action = {
                /**
                 * Get the current, paginated data set
                 * @return {Object} Current, paginated data set
                 */
                getCurrentDataSet: function() {
                    return m.pagedData[m.currentPage - 1];
                },

                /**
                 * Get the rel attribute for the next arrow
                 * @return {String} Rel attribute for the next arrow
                 */
                getNextRel: function() {
                    return m.currentPage === m.totalPages ? 'nofollow' : '';
                },

                /**
                 * Get the rel attribute for the previous arrow
                 * @return {String} Rel attribute for the previous arrow
                 */
                getPreviousRel: function() {
                    return m.currentPage === 1 ? 'nofollow' : '';
                },

                /**
                 * Is the arrow disabled?
                 * @param  {Number}  pageIndex Current pagination index
                 * @return {Boolean}           True, if the current page is disabled; false, otherwise.
                 */
                isDisabled: function(pageIndex) {
                    return m.currentPage === pageIndex;
                },

                /**
                 * Handler for a click event for the next arrow
                 * @param  {Object} event DOM Click Event
                 */
                onNextClicked: function(event) {
                    if (m.currentPage < m.totalPages) {
                        m.currentPage++;
                        scope.currentDataSet = a.getCurrentDataSet();

                        scope.$emit(Events.pagination.click, scope.currentDataSet);
                        scope.$emit(Events.pagination.next, scope.currentDataSet);
                    }
                },

                /**
                 * Handler for a click event for the previous arrow
                 * @param  {Object} event DOM Click Event
                 */
                onPreviousClicked: function(event) {
                    if (m.currentPage > 1) {
                        m.currentPage--;
                        scope.currentDataSet = a.getCurrentDataSet();

                        scope.$emit(Events.pagination.click, scope.currentDataSet);
                        scope.$emit(Events.pagination.previous, scope.currentDataSet);
                    }
                },

                /**
                 * Initialize the dataset for pagination.
                 * Also resets to the first page.
                 * @param {Object} data The dataset
                 */
                setPaginationData: function(data) {
                    m.currentPage = 1;
                    m.pagedData = _.chunk(data, m.itemsPerPage);
                    m.totalPages = m.pagedData.length;

                    scope.currentDataSet = a.getCurrentDataSet();
                }
            };

            function init() {
                m.itemsPerPage = attrs.itemsPerPage || AnthroConfig.pagination.defaultItemsPerPage;

                a.setPaginationData(scope.dataSet);

                scope.$emit(Events.pagination.load, scope.currentDataSet);
                scope.$watch('dataSet', a.setPaginationData);
            }

            init();
        },
        restrict: 'E',
        scope: {
            currentDataSet: "=?paginatedDataset",
            dataSet: '=dataset'
        },
        templateUrl: '/anthro/partials/pagination.html'
    };
};
